export default "__VITE_ASSET__CkborJ$S__"